import { appFormUtil } from 'modules/common';
import { emit } from 'process';
import React from 'react';
const initialState = {
  code: '',
  email: '',
  password: '',
  confirmPassword: '',
  emailSent: false
};

export type IFormState = typeof initialState;

export interface IData { }

export function useQuery() {

  const form = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      email: {
        label: 'Enter your email',
        type: 'email',
        required: true
      },
      password: {
        label: 'New Password',
        type: 'password',
        required: true
      },
      confirmPassword: {
        label: 'Confirm Password',
        type: 'password',
        required: true,
        fnValidate: (e) => {
          if (typeof e !== 'string') {
            return '';
          } else if (e.length >= 8 && e !== form.formState.password) {
            return 'Passwords do not match';
          } else return '';
        }
      },
      code: {
        label: 'Code',
        type: 'text',
        required: true
      }
    }
  });
  return React.useMemo(
    () => {

      return {
        form
      };
    },
    [form]
  );
}
